import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

// 获取 token 信息
export function getToken() {
  return Cookies.get(TokenKey)
}

// 设置 token 有效时间为2小时
export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 2/24 })
}
// 清除 token 信息
export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js